import React from "react";
import { AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa6";
import { Link } from "react-router-dom";
import footerLogo from "../assets/images/maskedLogo.svg";

type Nav = {
  name: string;
  path: string;
};

const navigation: Nav[] = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Services",
    path: "/services",
  },
  {
    name: "Team",
    path: "/team",
  },
  {
    name: "Blog",
    path: "/blogs",
  },
];

const resources: Nav[] = [
  {
    name: "Documentation",
    path: "/",
  },
  {
    name: "Privacy Policy",
    path: "/privacy-policy",
  },
  {
    name: "Terms Service",
    path: "/terms-service",
  },
  {
    name: "Press files",
    path: "/press-files",
  },
  {
    name: "Contact",
    path: "/contact-us",
  },
];

const workingHours = [
  {
    day: "Monday - Friday",
    time: "07.00 - 23.00",
  },
  {
    day: "Saturday",
    time: "07.00 - 20.00",
  },
  {
    day: "Sunday",
    time: "10.00 - 18.00",
  },
];

const contacts = [
  {
    title: "Phone no.",
    content: "+44485543091",
    link: "tel:+44485543091",
  },
  {
    title: "Email",
    content: "laila.khan@psycheethos.com",
    link: "mailto:laila.khan@psycheethos.com",
  },
  {
    title: "Location",
    content: "71-75 Shelton Street Covent Garden london WC2 9JQ U.K.",
    link: "https://www.google.com/maps/place/71-75+Shelton+St,+London/@51.5122552,-0.1315678,17z/data=!3m1!4b1!4m5!3m4!1s0x48761b1d5c8b6c2d:0x4b6c7b4e2f2c0d2!8m2!3d51.5122552!4d-0.1315678",
  },
];

const Footer = () => {
  return (
    <footer className="w-full flex justify-center items-center bg-black text-white">
      <div className="py-10 sm:py-20 w-full text-center max-w-screen-2xl">
        <div className="grid gap-4 sm:gap-10 grid-cols-1 md:grid-cols-3 xl:grid-cols-4 px-4 sm:px-12">
          <div className="flex flex-col gap-4">
            <img src={footerLogo} alt="footerLogo" />
            <p className="text-start opacity-50">
              Seeking professional help is not a weakness.
            </p>
            <div className="flex gap-4">
              <div
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/nightstarstorytelling/",
                  )
                }
                className="border rounded-full hover:bg-primary cursor-pointer flex p-2 justify-center items-center"
              >
                <AiFillInstagram className="w-7 h-7" />
              </div>
              <div className="border rounded-full hover:bg-primary cursor-pointer flex p-2 justify-center items-center">
                <FaLinkedinIn className="w-7 h-7" />
              </div>
              <div className="border rounded-full hover:bg-primary cursor-pointer flex p-2 justify-center items-center">
                <FaFacebookF className="w-7 h-7" />
              </div>
            </div>
          </div>
          <div className="flex flex-col mx-4 sm:mx-10 text-start">
            <h3 className="uppercase text-xl">Explore</h3>
            <div className="py-2">
              {navigation.map((item) => (
                <div key={item.name} className="py-1">
                  <Link
                    to={item.path}
                    className="hover:underline"
                    onClick={() => {
                      window.scrollTo(0, 0);
                    }}
                  >
                    {item.name}
                  </Link>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col mx-4 sm:mx-10 text-start">
            <h3 className="uppercase text-xl">Working hours</h3>
            <div className="py-2">
              {workingHours.map((item) => (
                <div key={item.day} className="py-2">
                  <div className="text-lg">{item.day}</div>
                  <div>{item.time}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col mx-4 sm:mx-10 text-start">
            <h3 className="uppercase text-xl">Contact</h3>
            <div className="py-2">
              {contacts.map((item) => (
                <div key={item.title} className="py-2">
                  <div className="text-lg">{item.title}</div>
                  <a
                    href={item.link}
                    className="hover:underline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.content}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-4 opacity-50 jost-regular">
          Copyright © 2024{" "}
          <span onClick={() => window.open("https://techqilla.com")}>
            TechQilla
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
